import { Box, CircularProgress, Grid } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { Form, Formik } from "formik"
import React from "react"
import { useHistory } from "react-router-dom"
import { sendEmail } from "../../_actions/email_actions"
import ColorAndLogoForm from "./createPlateformPage/form/colorAndLogoForm"
import ContactForm from "./createPlateformPage/form/contactForm"
import createPlateformFormModel from "./createPlateformPage/formModel/createPlateformFormModel"
import formInitialValues from "./createPlateformPage/formModel/formInitialValues"
import validationSchema from "./createPlateformPage/formModel/validationSchema"

const SHARED_LOGO_URL = "https://pgm-media.fteledition.fr/Uploads/f81fbd49-c7b5-4198-8cd6-e8710c446194/logo_n.png"

const useStyles = makeStyles((theme) => ({
  actionButton: {
    marginTop: theme.spacing(2),
  },
  root: {
    "& .MuiInputBase-input": { color: "#1f2937" },
    "& .MuiFormHelperText-root": { marginLeft: 0 },
    padding: theme.spacing(2),
  },
  formWrapper: {
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      maxWidth: 560,
      margin: "0 auto",
    },
  },
  formContent: {
    [theme.breakpoints.up("lg")]: {
      minHeight: "calc(100vh - 170px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  firstStepIntro: {
    marginBottom: theme.spacing(3),
  },
  firstStepLogoWrap: {
    textAlign: "center",
    marginTop: theme.spacing(4),

    marginBottom: theme.spacing(4),
  },
  firstStepLogo: {
    width: 190,
    maxWidth: "100%",
  },
  firstStepTitle: {
    fontFamily: "Montserrat-Bold",
    color: "#1f2937",
    marginBottom: theme.spacing(1.5),
    fontSize: "1.5rem",
  },
  firstStepDescription: {
    color: "#374151",
    fontSize: "0.95rem",
    lineHeight: 1.6,
    marginBottom: theme.spacing(1),
  },
  firstStepInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#ffffff",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#d7dbe0",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#c5cbd3",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f5b800",
      borderWidth: 1,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#98a1ad",
      opacity: 1,
    },
  },
  firstStepSubmit: {
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#f5b800",
    color: "#ffffff",
    fontFamily: "Montserrat-Bold",
    justifyContent: "space-between",
    padding: theme.spacing(1.1, 1.8),
    "&:hover": {
      backgroundColor: "#dea900",
    },
  },
  finalStepSubmit: {
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#f5b800",
    color: "#ffffff",
    fontFamily: "Montserrat-Bold",
    justifyContent: "space-between",
    padding: theme.spacing(1.1, 1.8),
    "&:hover": {
      backgroundColor: "#dea900",
    },
  },
  finalStepBack: {
    borderRadius: 8,
    border: "1px solid #d7dbe0",
    color: "#374151",
    textTransform: "none",
    padding: theme.spacing(1.1, 1.8),
  },
  firstStepArrow: {
    fontSize: "1.2rem",
    lineHeight: 1,
  },
  infoText: {
    fontSize: "0.82rem",
    textAlign: "left",
    color: "#374151",
    marginTop: theme.spacing(1.3),
  },
}))

function getSteps() {
  return ["Vos informations personnelles", "Votre jeu concours"]
}

function getPackTypeByNbUsers(nbUsers) {
  const totalUsers = Number(nbUsers) || 0
  if (totalUsers <= 250) return 0
  if (totalUsers <= 1000) return 1
  return 2
}

const { formId, formField } = createPlateformFormModel
function getStepContent(step, values, setFieldValue, classes) {
  switch (step) {
    case 0:
      return <ContactForm formField={formField} inputClassName={classes.firstStepInput} />
    case 1:
      return <ColorAndLogoForm values={values} formField={formField} setFieldValue={setFieldValue} />
    default:
      return null
  }
}

export default function CustomStepper() {
  const [activeStep, setActiveStep] = React.useState(0)
  const steps = getSteps()
  const classes = useStyles()
  const currentValidationSchema = validationSchema[activeStep]
  const isFirstStep = activeStep === 0
  const isLastStep = activeStep === steps.length - 1
  const history = useHistory()

  const handleBack = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setActiveStep((prevStep) => Math.max(prevStep - 1, 0))
  }

  async function _sendMail(values) {
    const valuesToSend = { ...values, TypePack: getPackTypeByNbUsers(values.NbUsers), NbUsers: Number(values.NbUsers) }
    const toSend = JSON.stringify(valuesToSend, null, 2)
    return sendEmail(toSend)
  }

  async function _handleSubmit(values, actions) {
    actions.setTouched({})

    if (!isLastStep) {
      try {
        await _sendMail(values)
        setActiveStep((prevStep) => prevStep + 1)
      } finally {
        actions.setSubmitting(false)
      }
      return
    }

    try {
      await _sendMail(values)
      history.push("/finish")
    } finally {
      actions.setSubmitting(false)
    }
  }

  return (
    <Box className={classes.root}>
      <Box>
        {activeStep !== steps.length ? (
          <Formik initialValues={formInitialValues} validationSchema={currentValidationSchema} onSubmit={_handleSubmit}>
            {(props) => {
              const { isSubmitting, values, setFieldValue, handleSubmit } = props

              return (
                <Form id={formId} onSubmit={handleSubmit} className={classes.formWrapper}>
                  <Box className={classes.firstStepLogoWrap}>
                    <img className={classes.firstStepLogo} alt='Pronostic Games' src={SHARED_LOGO_URL} />
                  </Box>

                  <Box className={classes.formContent}>
                    {isFirstStep && (
                      <Box className={classes.firstStepIntro}>
                        <Typography className={classes.firstStepTitle}>Création de votre plateforme</Typography>
                        <Typography className={classes.firstStepDescription}>
                          Afin de créer gratuitement votre plateforme de test aux couleurs de votre entreprise, nous avons besoin de quelques informations vous
                          concernant vous et votre société. Ces informations seront uniquement utilisées pour vous recontacter et faciliter nos échanges.
                        </Typography>
                      </Box>
                    )}

                    {getStepContent(activeStep, values, setFieldValue, classes)}

                    <Box className={classes.actionButton}>
                      {isFirstStep ? (
                        <Grid container>
                          <Grid item xs={12}>
                            <Button type='submit' variant='contained' color='primary' className={classes.firstStepSubmit} disabled={isSubmitting}>
                              {isSubmitting ? (
                                <CircularProgress size={24} />
                              ) : (
                                <>
                                  Suivant
                                  <span className={classes.firstStepArrow}>›</span>
                                </>
                              )}
                            </Button>

                            <Typography className={classes.infoText}>
                              Notre politique de confidentialité{" "}
                              <a target='_blank' href='https://www.pronosticgames.fr/politique-de-confidentialite' rel='noreferrer'>
                                ici
                              </a>
                            </Typography>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid container spacing={2} alignItems='center'>
                          <Grid item xs={12} md='auto'>
                            <Button type='button' onClick={(event) => handleBack(event)} className={classes.finalStepBack}>
                              Retour
                            </Button>
                          </Grid>
                          <Grid item xs={12} md>
                            <Button type='submit' variant='contained' color='primary' className={classes.finalStepSubmit} disabled={isSubmitting}>
                              {isSubmitting ? (
                                <CircularProgress size={24} />
                              ) : (
                                <>
                                  Créer ma plateforme
                                  <span className={classes.firstStepArrow}>›</span>
                                </>
                              )}
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography className={classes.infoText}>
                              Notre politique de confidentialité{" "}
                              <a target='_blank' href='https://www.pronosticgames.fr/politique-de-confidentialite' rel='noreferrer'>
                                ici
                              </a>
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                  </Box>
                </Form>
              )
            }}
          </Formik>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  )
}
